import domainAPI from '@api/domain'
import getErrorMessage from '@utils/getErrorMessage'

import {
  DOMAIN_LIST_BEGIN,
  DOMAIN_LIST_SUCCESS,
  DOMAIN_LIST_FAILURE,
  DOMAIN_CREATE_BEGIN,
  DOMAIN_CREATE_SUCCESS,
  DOMAIN_CREATE_FAILURE,
  DOMAIN_UPDATE_BEGIN,
  DOMAIN_UPDATE_SUCCESS,
  DOMAIN_UPDATE_FAILURE,
  DOMAIN_DELETE_BEGIN,
  DOMAIN_DELETE_SUCCESS,
  DOMAIN_DELETE_FAILURE,
  DOMAIN_CLEAR,
} from './_types'

const getDefaultState = () => {
  return {
    domains: [],
    domainActionCompleted: false,
    domainActionError: false,
    domainActionLoading: false,
    domainErrorMessage: '',
  }
}

export const state = getDefaultState()

export const mutations = {
  [DOMAIN_LIST_BEGIN](state) {
    state.domainActionCompleted = false
    state.domainActionLoading = true
    state.domainActionError = false
  },
  [DOMAIN_LIST_SUCCESS](state, domains) {
    state.domains = domains
    state.domainActionCompleted = true
    state.domainActionLoading = false
  },
  [DOMAIN_LIST_FAILURE](state, message) {
    state.domainActionError = true
    state.domainActionLoading = false
    state.domainActionCompleted = true
    state.domainErrorMessage = message
  },
  [DOMAIN_CREATE_BEGIN](state) {
    state.domainActionLoading = true
    state.domainActionError = false
    state.domainActionCompleted = false
  },
  [DOMAIN_CREATE_SUCCESS](state, domain) {
    state.domains.push(domain) // Assuming the response is the new domain object
    state.domainActionCompleted = true
    state.domainActionLoading = false
  },
  [DOMAIN_CREATE_FAILURE](state, message) {
    state.domainActionError = true
    state.domainActionLoading = false
    state.domainActionCompleted = true
    state.domainErrorMessage = message
  },
  [DOMAIN_UPDATE_BEGIN](state) {
    state.domainActionLoading = true
    state.domainActionError = false
    state.domainActionCompleted = false
  },
  [DOMAIN_UPDATE_SUCCESS](state, updatedDomain) {
    const index = state.domains.findIndex(d => d.id === updatedDomain.id)
    if (index !== -1) {
      state.domains.splice(index, 1, updatedDomain)
    }
    state.domainActionCompleted = true
    state.domainActionLoading = false
  },
  [DOMAIN_UPDATE_FAILURE](state, message) {
    state.domainActionError = true
    state.domainActionLoading = false
    state.domainActionCompleted = true
    state.domainErrorMessage = message
  },
  [DOMAIN_DELETE_BEGIN](state) {
    state.domainActionLoading = true
    state.domainActionError = false
    state.domainActionCompleted = false
  },
  [DOMAIN_DELETE_SUCCESS](state, deletedDomainId) {
    state.domains = state.domains.filter(
      domain => domain.id !== deletedDomainId)
    state.domainActionCompleted = true
    state.domainActionLoading = false
  },
  [DOMAIN_DELETE_FAILURE](state, message) {
    state.domainActionError = true
    state.domainActionLoading = false
    state.domainActionCompleted = true
    state.domainErrorMessage = message
  },
  [DOMAIN_CLEAR](state) {
    Object.assign(state, getDefaultState())
  },
}

export const actions = {
  listDomains({ commit }) {
    commit(DOMAIN_LIST_BEGIN)

    return domainAPI.listDomains()
      .then((response) => {
        commit(DOMAIN_LIST_SUCCESS, response.data)
      }).catch((error) => {
        const errorMessage = getErrorMessage(error)
        commit(DOMAIN_LIST_FAILURE, errorMessage)
      })
  },
  createDomain({ commit }, domainData) {
    commit(DOMAIN_CREATE_BEGIN)
    return domainAPI.createDomain(domainData)
      .then(response => {
        commit(DOMAIN_CREATE_SUCCESS, response.data)
        if (window.Tawk_API) {
          window.Tawk_API.addEvent('create-domain', {
            'id': response.data.id,
            'url': response.data.url,
          }, function (error) {
            console.log('Error adding event:', error)
          })
        }
        return response.data.id
      })
      .catch((error) => {
        const errorMessage = getErrorMessage(error)
        commit(DOMAIN_CREATE_FAILURE, errorMessage)
      })
  },
  updateDomain({ commit }, domainData) {
    commit(DOMAIN_UPDATE_BEGIN)
    return domainAPI.updateDomain(domainData)
      .then(response => {
        commit(DOMAIN_UPDATE_SUCCESS, response.data)
      })
      .catch((error) => {
        const errorMessage = getErrorMessage(error)
        commit(DOMAIN_UPDATE_FAILURE, errorMessage)
      })
  },
  deleteDomain({ commit }, domainId) {
    commit(DOMAIN_DELETE_BEGIN)
    return domainAPI.deleteDomain(domainId)
      .then(() => {
        commit(DOMAIN_DELETE_SUCCESS, domainId)
      })
      .catch((error) => {
        const errorMessage = getErrorMessage(error)
        commit(DOMAIN_DELETE_FAILURE, errorMessage)
      })
  },
   clearState({ commit }) {
    commit(DOMAIN_CLEAR)
  },
}